import type { AuthData } from '~/models/auth'

export function useAuthCookie() {
  const { load, cookie } = useAppCookie<AuthData | null>('gateway-auth', {
    // TODO: timeout overflow issue with maxAge > 24 days, watch and revert to 2 years (2 * 365 * 24 * 60 * 60) once fixes https://github.com/nuxt/nuxt/issues/24227
    maxAge: 24 * 24 * 60 * 60,
    domain: useDomain(),
  })

  return { load, cookie }
}
